import Pararax from './pararax';
import Contents from './contents';

export default class smoothScrollManager{
    constructor(effect,pageID){

        this.pararax = new Pararax();
        this.contents = new Contents(effect,pageID);

        this.w = window.innerWidth;
        this.h = window.innerHeight;
        this.fpsRate;
        this.pageID;

        this.$bodyTag;
        this.$root;
        this.$container;
        this.$body;


        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.dir = "next";
        this.add = 0.1;
        this.skew = 200;
        this.skewInc = 0;

        this.paraPoint = [];

        this.timer = [];

        this.type = "normal";

        this.inertia = (Useragnt.safari||Useragnt.mobile||Useragnt.tablet||$('html.ie')[0])?false:true; /* 慣性スクロールを有効にするか */


        /* 状態監視用のフラグ */
        this.status = {
            comp     : false, /* 慣性スクロールが完了したか */
            pagetop : false, // ページトップ移動か
            deviceSize : "",
            progress : 1, // スクロール毎に終着点までの進捗を監視
            mode : "normal",//[ normal:ボディをスクロール制御 // select:指定したidをスクロール制御 ]
            temp : {//前回の状態保存。modeを切り替える際に使用する
                inc : 0,
                nowInc:0,
                prevInc:0,
                dir : "",
            }
        }

        //他のモジュール機能
        this.gnavi;

    }
    init(pageID,gnavi){

        this.pageID = pageID;
        this.$bodyTag = document.getElementsByTagName('body');
        this.$root = document.getElementById("l-root");
        this.$container = document.getElementById("barba-wrapper");
        this.$body = document.querySelector(".barba-container");

        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.dir = "next";
        this.add = 0.1;
        this.skew = 200;

        // pararax.init();
        if(!this.inertia) this.$bodyTag[0].classList.add('is-inertia-none');


        if(this.contents) this.contents.init(pageID);
        if(this.pararax) this.pararax.init();

        this.gnavi = gnavi;

        TweenLite.to(window, 0.1, {scrollTo:{y:0,autoKill:false}});

    }
    changeMode(select,$body){


        if(select=="normal"){
            this.$body = document.getElementById("l-scroll-body");

        }else{
            this.$body = $body;
        }

        if(this.inertia) {
            if (select == "normal") {
                this.inc = this.status.temp.inc;
                this.nowInc = this.status.temp.nowInc;
                this.prevInc = this.status.temp.prevInc;
                this.dir = this.status.temp.dir;
                this.skew = 200;
                this.resize(window.innerWidth, window.innerHeight);
                setTimeout(() => {
                    this.status.mode = select;
                    this.to(this.inc);
                }, 1e2);
            } else {
                this.status.mode = select;
                this.status.temp.inc = this.inc;
                this.status.temp.nowInc = this.nowInc;
                this.status.temp.prevInc = this.prevInc;
                this.status.temp.dir = this.dir;
                this.skew = 20;
                this.resize(window.innerWidth, window.innerHeight);
                this.reset();
            }
        }

    }
    to(inc){
        TweenLite.to(window, !this.inertia?1:0.0001, {scrollTo:{y:inc,autoKill:false}});
    }
    reset(){
        // console.log("scroll reset")
        this.to(0);
        this.update(0,"prev");
        this.nowInc = 0;
        this.add = 1; // 一瞬イージングなし
        this.trans();
        this.add = 0.1; // イージング戻す
    }
    loadUpdate(){
        if(!this.inertia) this.$bodyTag[0].classList.add('is-inertia-none');
        // this.reset();
    }
    update(inc,dir){ /* スクロール方向を決めうちしないならdirは空で渡してください */
        this.inc = inc;
        this.dir = !dir ? this.inc>this.prevInc?"next":"prev":dir;
        //this.mouse = mouse;
        // this.prevInc = this.inc;
        this.mode = "scroll";
        this.status.comp = false;

    }
    move(fpsRate,webgl) {

        // if(this.status.comp||inc==undefined) return;
        if(this.inc==undefined||this.status.comp) return;

        this.nowInc += this.add * (this.inc - this.nowInc)*fpsRate;
        // this.status.progress = this.inc>0?this.dir=="next"?Math.abs(this.nowInc/this.inc):Math.abs(this.inc/this.nowInc):1;


        this.trans(fpsRate);

    }
    trans(fpsRate) {


        if(this.inertia){
            this.$body.style.transform = 'translateY(-'+ this.nowInc +'px)'

        }

        /* スクロール連動で動作 */
        if(this.status.mode=="normal"){
            if(this.pararax) this.pararax.mot(this.nowInc,this.status.progress,fpsRate);
            this.contents.update(this.inc,this.dir);
        }
        if(
            this.prevInc>this.nowInc-0.1&&this.dir=="next" ||
            this.prevInc<this.nowInc+0.1&&this.dir=="prev"
        ){
            this.onComplete();
        }
        this.prevInc = this.nowInc;
    }

    resize (w,h) {
        this.w = w;
        this.h = h;

        if(this.inertia) {
            TweenMax.set(this.$root, {"height": this.$body.clientHeight + 129});
        }

        this.pararax.resize(h);
        this.contents.resize(this.h);
    }

    /* -------------------------------------------

      -- Callback

    ------------------------------------------- */

    onComplete(){ /* スクロール動作が終わったら */
        this.status.comp = true;
        this.status.pagetop = false;
        // this.nowInc = this.inc;
        // this.move(this.fpsRate)
    }

    /* -------------------------------------------

      -- ステータスいじいじするやつ

    ------------------------------------------- */

    datGUI(){

    }
}